import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

const Iletisim = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 5 }}>
            <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
                Bize Ulaşın
            </Typography>
            <Grid container spacing={4}>
                {/* İletişim Bilgileri */}
                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="h6" fontWeight="bold">
                            İletişim Bilgilerimiz
                        </Typography>

                        <Typography variant="body2" color="textSecondary">
                            Yardımcı olmak için buradayız. Bizimle telefon, iletişim formu veya e-posta kanallarımız aracılığıyla iletişime geçin.
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                            <LocationOnIcon sx={{ mr: 1, color: "primary.main" }} />
                            <Typography variant="body1">
                                Alibey Mah. Başkomutan Cad. Özel İdare İş Merkezi K:5 D:53, Silivri - İstanbul
                            </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                            <PhoneIcon sx={{ mr: 1, color: "primary.main" }} />
                            <Typography variant="body1">0552 167 36 34</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                            <EmailIcon sx={{ mr: 1, color: "primary.main" }} />
                            <Typography variant="body1">gulden.cetinkayakopan@ismmmo.org.tr</Typography>
                        </Box>
                    </Box>
                </Grid>
                {/* Google Maps */}
                <Grid item xs={12} md={6}>
                    <Box sx={{ width: "100%", height: "100%", minHeight: "300px" }}>
                        <iframe
                            title="Harita Konumu"
                            width="100%"
                            height="300"
                            style={{ border: 0 }}
                            loading="lazy"
                            allowFullScreen
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d751.9484947501136!2d28.247402769654038!3d41.07349580922414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b51583992a907d%3A0xa650e900249b47dd!2zU2lsaXZyaSDDlnplbCDEsGRhcmUgxLDFnyBNZXJrZXpp!5e0!3m2!1str!2str!4v1738317982767!5m2!1str!2str"
                        ></iframe>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Iletisim;